export default {
  FULL_PERMISSION_INFO_MAP: 'admin:full_permission_info_map'
}
